import { Component } from '@angular/core';

@Component({
  selector: 'allas-porque-cotizar-por-whatsapp',
  imports: [],
  template: `
    <section class="flex flex-col gap-1 xl:gap-2 mt-6">
      <h2 class="text-xl xl:text-4xl font-bold fs-condensed text-center">
        ¿POR QUÉ COTIZAR POR WHATSAPP?
      </h2>
      <p
        class="text-sm xl:text-lg fs-condensed text-center text-gray-700 xl:text-black"
      >
        La forma más rápida y conveniente de obtener precios de repuestos
        automotrices.
      </p>

      <div
        class="grid grid-cols-1 xl:grid-cols-4 mt-14 xl:mt-16 gap-8 xl:gap-0"
      >
        <!-- Repuesta Rápida -->
        <div class="flex flex-col gap-2">
          <img
            src="/allas-icons/clock.svg"
            alt="Reloj en movimiento"
            class="w-auto h-20"
          />
          <h3 class="xl:text-3xl text-2xl font-bold fs-condensed text-center">
            Respuesta Rápida
          </h3>
          <p
            class="text-md xl:text-lg fs-condensed text-center text-gray-700 xl:text-black"
          >
            Obtén tu cotización en minutos. Nuestro <br />
            equipo responde de inmediato durante <br />
            horarios extendidos.
          </p>
        </div>
        <!-- Fácil y Conveniente -->
        <div class="flex flex-col gap-2">
          <img
            src="/allas-icons/hand-fast.svg"
            alt="Mano con dedo índice y pulgar juntos"
            class="w-auto h-20"
          />
          <h3 class="xl:text-3xl text-2xl font-bold fs-condensed text-center">
            Fácil y Conveniente
          </h3>
          <p
            class="text-md xl:text-lg fs-condensed text-center text-gray-700 xl:text-black"
          >
            Solo envía una foto o descripción del <br />
            repuesto que necesitas y para qué <br />
            vehículo lo necesitas ¡Así de simple!
          </p>
        </div>
        <!-- Sin Compromiso -->
        <div class="flex flex-col gap-2">
          <img
            src="/allas-icons/message.svg"
            alt="Icono de mensaje"
            class="w-auto h-20"
          />
          <h3 class="xl:text-3xl text-2xl font-bold fs-condensed text-center">
            Sin Compromiso
          </h3>
          <p
            class="text-md xl:text-lg fs-condensed text-center text-gray-700 xl:text-black"
          >
            Cotiza sin presión. Puedes consultar <br />
            precios y disponibilidad sin <br />
            obligación de compra.
          </p>
        </div>
        <!-- Atención Personalizada -->
        <div class="flex flex-col gap-2">
          <img
            src="/allas-icons/call-center.svg"
            alt="Icono de centro de llamadas"
            class="w-auto h-20"
          />
          <h3 class="xl:text-3xl text-2xl font-bold fs-condensed text-center">
            Atención Personalizada
          </h3>
          <p
            class="text-md xl:text-lg fs-condensed text-center text-gray-700 xl:text-black"
          >
            Comunicate directamente con uno <br />
            de nuestros asesores expertos en <br />
            repuestos automotrices.
          </p>
        </div>
      </div>
    </section>
  `,
})
export class PorqueCotizarPorWhatsapp {}
